import { namespace } from 'vuex-class';
import { IVideoLinkState } from '@/video/link/store/video-link.types';

export const VideoLink = namespace('video/videoLink');

export enum EVideoLinkAction {
  SetURL = 'setURL',
  SetTitle = 'setTitle',
  CreateVideo = 'createVideo',
  CreateVideoFailed = 'createVideoFailed',
  CreateVideoSuccess = 'createVideoSuccess',
  TogglePreview = 'togglePreview',
  ClearData = 'clearData',
}

export enum EVideoLinkMutation {
  SetVideoURL = 'setVideoURL',
  SetVideoTitle = 'setVideoTitle',
  SetLoading = 'setLoading',
  SetCreatedVideoId = 'setCreatedVideoId',
  TogglePreview = 'togglePreview',
  SetFeedbackMessage = 'setFeedbackMessage',
  ResetState = 'resetState',
}

export const state: IVideoLinkState = {
  url: null,
  title: null,
  loading: false,
  createdVideoId: null,
  showPreview: false,
  feedbackMessage: null,
};
